
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowFlyoutGoogle as ObiArrowFlyoutGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-flyout-google.js';
 
 
 

 
 export const ObiArrowFlyoutGoogle = createComponent({
   react: React,
   tagName: 'obi-arrow-flyout-google',
   elementClass: ObiArrowFlyoutGoogleElement,
   events: {
     
   }
  });
 
 